import React, { useState, useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  saveToGlobalState,
  getStoredData,
  removeSpecificData,
} from "../../utils/localStorage";

import airplane from "../../assets/airplane.svg";
import bus from "../../assets/bus.svg";
import railwayStation from "../../assets/railway-station.svg";
import car from "../../assets/car.svg";
import motorcycle from "../../assets/motorcycle.svg";

const options = [
  { id: "aviao", label: "AVIÃO", image: airplane },
  { id: "onibus", label: "ÔNIBUS", image: bus },
  //{ id: "trem", label: "TREM", image: railwayStation },
  { id: "carro", label: "CARRO", image: car },
  { id: "moto", label: "MOTO", image: motorcycle },
];

const QualMeioTransporteCadastramento = () => {
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);
  const [selected, setSelected] = useState(() => {
    const savedData = getStoredData();
    return savedData.qual_meio_transporte || "";
  });

  const colors = {
    primary: "#00bad4",
    text: "#00bad4",
  };

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      return;
    }

    if (selected) {
      removeSpecificData("cidade_origem");
      removeSpecificData("cidade_origem_main");
      removeSpecificData("cidade_destino");
      removeSpecificData("cidade_destino_main");
      removeSpecificData("cidades_trajeto");
      removeSpecificData("current_step");
      removeSpecificData("lat_cidade_origem");
      removeSpecificData("lng_cidade_origem");
      removeSpecificData("lat_cidade_destino");
      removeSpecificData("lng_cidade_destino");
      removeSpecificData("horas_ida_viagem");
      removeSpecificData("horas_ida_destino");
      removeSpecificData("origemHora");
      removeSpecificData("destinoHora");
      removeSpecificData("origemData");
      removeSpecificData("destinoData");
      removeSpecificData("lat_cidade_origem");
      removeSpecificData("lng_cidade_origem");
      removeSpecificData("lat_cidade_destino");
      removeSpecificData("lng_cidade_destino");
      removeSpecificData("place_id_origem");
      removeSpecificData("place_id_destino");
      removeSpecificData("search_origem");
      removeSpecificData("search_destino");
      removeSpecificData("dia_mes_ano_ida_viagem");
      removeSpecificData("dia_mes_ano_ida_viagem_para_busca");
      removeSpecificData("dia_mes_ano_ida_destino");
      removeSpecificData("dia_mes_ano_ida_destino_para_busca");
      removeSpecificData("editar_trajeto");
      removeSpecificData("id");
      removeSpecificData("pais_origem");
      removeSpecificData("pais_destino");
      removeSpecificData("select_espaco_mala");
      removeSpecificData("qual_meio_transporte");
      removeSpecificData("voltando_trajeto");
      removeSpecificData("informacao_a_viagem");
      removeSpecificData("viagem_step");
      saveToGlobalState({ qual_meio_transporte: selected });
      setTimeout(() => navigate(`/${selected}`), 300);
    }
  }, [selected, initialized, navigate]);

  return (
    <>
      <Container maxWidth="lg" sx={{ py: 8, textAlign: "center" }}>
        <Typography
          variant="h5"
          sx={{
            color: colors.text,
            fontWeight: 700,
            fontFamily: "Gotham",
            mb: 5,
          }}
        >
          <h2 className="title-main">
            Qual será o meio de transporte que você irá viajar?
          </h2>
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 3,
          }}
        >
          {options.map((item) => (
            <Box
              key={item.id}
              onClick={() => setSelected(item.id)}
              sx={{
                width: { xs: 120, sm: 150 },
                height: { xs: 120, sm: 150 },
                borderRadius: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                backgroundColor: "rgba(255, 255, 255, 1)",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
                transition: "all 0.3s ease",
                border:
                  selected === item.id
                    ? `2px solid ${colors.primary}`
                    : "2px solid transparent",

                "&:hover": {
                  transform: "scale(1.08)",
                  boxShadow: "0px 12px 30px rgba(0,0,0,0.30)",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  color: colors.text,
                  fontWeight: 800,
                  fontFamily: "Gotham",
                  mb: 2,
                }}
              >
                {item.label}
              </Typography>

              <Box
                component="img"
                src={item.image}
                alt={item.label}
                sx={{
                  width: { xs: 50, sm: 65 },
                  height: { xs: 50, sm: 65 },
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </>
  );
};

export default QualMeioTransporteCadastramento;
